const UNSHIPPED_ID = "unshipped";

function itemId(item) {
  return String(item?.id ?? "");
}

function assignmentKey(item, index) {
  return `${itemId(item)}:${index}`;
}

function findUnassignedItemIndex(lineItems, id, assignedIds) {
  return lineItems.findIndex(
    (item, index) =>
      itemId(item) === String(id) &&
      !assignedIds.has(assignmentKey(item, index)),
  );
}

function itemsForShipment(lineItems, shipment, assignedIds) {
  const items = [];

  (shipment.line_item_ids ?? []).forEach((id) => {
    const matchIndex = findUnassignedItemIndex(lineItems, id, assignedIds);
    if (matchIndex === -1) {
      return;
    }

    const lineItem = lineItems[matchIndex];
    assignedIds.add(assignmentKey(lineItem, matchIndex));
    items.push({ lineItem, formIndex: matchIndex });
  });

  return items;
}

function unshippedItems(lineItems, assignedIds) {
  return lineItems.flatMap((lineItem, formIndex) => {
    if (assignedIds.has(assignmentKey(lineItem, formIndex))) {
      return [];
    }
    return [{ lineItem, formIndex }];
  });
}

export function groupLineItemsByPackage(order) {
  const lineItems = order?.line_items ?? [];
  const shipments = order?.shipments ?? [];
  const assignedIds = new Set();
  const groups = [];

  shipments.forEach((shipment, shipmentIndex) => {
    const items = itemsForShipment(lineItems, shipment, assignedIds);
    if (!items.length) {
      return;
    }

    groups.push({
      id: shipment.tracking_number || `shipment-${shipmentIndex}`,
      kind: "shipment",
      trackingNumber: shipment.tracking_number ?? null,
      status: shipment.status ?? null,
      items,
    });
  });

  const leftoverItems = unshippedItems(lineItems, assignedIds);
  if (leftoverItems.length) {
    groups.push({
      id: UNSHIPPED_ID,
      kind: "unshipped",
      trackingNumber: null,
      status: null,
      items: leftoverItems,
    });
  }

  return groups;
}

export function shouldShowPackageSections(groups) {
  return (groups?.length ?? 0) > 1;
}

export function itemSectionsForClaimForm(order) {
  const packageGroups = groupLineItemsByPackage(order);
  const showPackageSections = shouldShowPackageSections(packageGroups);
  if (showPackageSections) {
    return { showPackageSections, itemSections: packageGroups };
  }

  return {
    showPackageSections,
    itemSections: [
      {
        id: "all",
        kind: "all",
        items: (order?.line_items ?? []).map((lineItem, formIndex) => ({
          lineItem,
          formIndex,
        })),
      },
    ],
  };
}
